export default "__VITE_ASSET__3cXA6ujW__"